















































import { Component, Vue } from 'vue-property-decorator';
import { ApiClient, apiClient } from '@/api/ApiClient';
import moment from 'moment';
import TickCross from '@/components/TickCross.vue';
import { download } from '@/utils/file';
import camelcase from 'camelcase';
import { inRange } from 'lodash';
import { dateRangeTodayUntilEnd } from '@/utils/helper';

@Component({
  components: {
    TickCross,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  public get inRange() {
    return inRange;
  }

  // table filter
  public range: Date[] = dateRangeTodayUntilEnd();
  public state = '';
  public url = '';
  public method = '';
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  // filter option
  public get states() {
    return [
      {
        label: 'error',
        value: 'error',
      },
    ];
  }

  // table
  public isTableLoading = false;

  public pageSize = 100;
  public total = 0;
  public currentPage = 1;

  public data: any[] = [];
  public methods: any[] = [];

  public mounted() {
    this.init();
  }

  // table events
  public async onPaginationChange() {
    await this.loadData();
    this.$scrollTo("#data-table");
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadData();
  }

  //
  private async init() {
    await Promise.all([
      this.loadMethods(),
      this.loadData(),
    ]);
  }

  private async loadData() {
    this.isTableLoading = true;

    const { data } = await apiClient.logsRequests(this.getFilter());

    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  private async loadMethods() {
    const { data } = await apiClient.logsRequestsMethods();
    this.methods = data;
  }

  private getFilter() {
    const range = this.range || [];

    return {
      take: this.pageSize,
      page: this.currentPage,

      state: this.state,
      method: this.method,
      url: this.url,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      from: range[0],
      to: range[1],
    };
  }

}
